const stringifyUsd = (num) => {
  if (!num) return '$0.00';
  num = parseFloat(num);

  let head = '';
  if (num < 0) {
    head = '-';
    num *= -1;
  }
  const p = parseFloat(num).toFixed(2).split('.');
  const tail = (parseInt(p[1]) === 0 && num >= 1000) ? '' : '.' + p[1];

  const result = head + '$' + p[0].split('').reverse().reduce(function (acc, num, i, orig) {
    return num + (i && !(i % 3) ? ',' : '') + acc;
  }, '') + tail;
  return result;
};

// 5555555555 => +1 555 555 5555
const formatPhoneUSA = function (number, prefix) {
  return ('' + number).replace(/\D/g, '')
  // .replace(/^1/, '') // strip the leading "1" just in case
    .replace(/(\d)?(\d{3})?(\d{3})?(\d{4,8})?/, '+ $1 $2 $3 $4')
    .replace(/\s+/g, ' '); // this has to be done to avoid double/triple spaces
};

/**
 *  @param size {number}
 *  @return {string} formatted size like 122kb, 3Mb
 */
const parseSize = size => {
  let result = '';

  size = parseInt(size);
  size = size / 1024;
  result = 'kb';

  if (size < 1024) return parseInt(size) + result;

  size = size / 1024;
  result = 'Mb';

  return parseInt(size) + result;
};

export default {
  stringifyUsd,
  formatPhoneUSA,
  parseSize,
};



// WEBPACK FOOTER //
// ./src/globalsFn.js